import React, { useEffect, useContext, useState } from 'react';
import { AppSettings, externalAddress } from '../../config/app-settings.js';
import { Card, CardBody } from '../../components/card/card.jsx';
import { Icon } from '@iconify/react';
import { useLocation } from 'react-router-dom';

function Oferta() {

	const context = useContext(AppSettings);
	const location = useLocation();

	const [setup, setSetup] = useState('');

	useEffect(() => {
			context.setAppHeaderNone(false);
			context.setAppSidebarNone(true);
			context.setAppContentFullHeight(false);
			//context.setAppContentClass('p-0');

			const query = new URLSearchParams(location.search);
  			const setupParam = query.get('setup');
			setSetup(setupParam)

		}, []);


	return (
		<div>
			
			<Card>
				<CardBody className="p-0">
					<div className="row gx-0">
						<div className="col-xl-7 position-relative">
							<div className="p-4 p-lg-5">
								<div className="display-5 text-white mb-3">OFERTA DE LANÇAMENTO</div>
								<div className="mb-4 font-monospace lh-lg">
									O download de setups na biblioteca é exclusivo para assinantes dos planos <b className="text-theme d-inline-flex border-bottom border-1 border-theme">Quant Trader</b> ou <b className="text-theme d-inline-flex border-bottom border-1 border-theme">Black</b> do BotSpot.
								</div>
								<div className="mb-4 font-monospace lh-lg">
									Selecione um dos planos abaixo para poder utilizar os setups livremente no robô SDK.
								</div>
								
							</div>
						</div>
						
					</div>
				</CardBody>
			</Card>
		
			
			<div className="row gx-4 py-5">
				<div className="col-xl-3 col-md-6 py-3 py-xl-5">
					<Card className="h-100">
						<CardBody className="p-4 p-lg-5 d-flex flex-column">
							<div className="d-flex align-items-center">
								<div className="flex-1">
									<div className="h6 font-monospace mb-3">Quant Trader Mensal</div>
									<div className="display-6 mb-0 text-theme">R$ 197 <small className="h6 fw-light text-body text-opacity-50">/mês</small></div>
								</div>
								<div>
									<Icon className="display-4 text-theme" icon="solar:usb-line-duotone" />
								</div>
							</div>
							<hr className="my-4" />
							<div className="mb-5 text-body text-opacity-50 flex-1">
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Biblioteca de Setups:</span> <b className="text-body fw-semibold">Setups comuns</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Backtests:</span> <b className="text-body fw-semibold">Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Portfólios:</span> <b className="text-body fw-semibold">Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Realtime:</span> <b className="text-body fw-semibold">5 contas</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Histórico:</span> <b className="text-body fw-semibold"> 5 contas</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Simulação de Monte Carlo p/ Backtests:</span> <b className="text-body fw-semibold"> Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Simulação de Monte Carlo p/ Portfólios:</span> <b className="text-body fw-semibold"> Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">SDK:</span> <b className="text-body fw-semibold"> 2 contas</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">WFA p/ SDK:</span> <b className="text-body fw-semibold"> Habilitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Análise de Base de Dados:</span> <b className="text-body fw-semibold"> Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Auto Data Miner (BotSpot Explorer):</span> <b className="text-body fw-semibold"> Até 30 configurações</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">WFA p/ robôs proprietários:</span> <b className="text-body fw-semibold"> Não</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Análise de Volatilidade:</span> <b className="text-body fw-semibold"> Não</b></div>
								</div>
							</div>
							<div className="mx-n2">
								<a href="https://botspot.com.br/site/bs-redirect.html?to=buy.stripe.com/9AQdTNbLO8pR8IEeUX" target='_blank' className="btn btn-outline-theme btn-lg py-3 fs-13px w-100 font-monospace">Assinar <i className="fa fa-arrow-right"></i></a>
							</div>
						</CardBody>
					</Card>
				</div>
				<div className="col-xl-3 col-md-6 py-3 py-xl-5">
					<Card className="h-100">
						<CardBody className="p-4 p-lg-5 d-flex flex-column">
							<div className="d-flex align-items-center">
								<div className="flex-1">
									<div className="h6 font-monospace mb-3">Quant Trader Anual [OFERTA DE LANÇAMENTO]</div>
									<div className="display-6 mb-0 text-theme">R$ 1.500 <small className="h6 fw-light text-body text-opacity-50">/ano</small></div>
								</div>
								<div>
									<Icon className="display-4 text-theme" icon="solar:map-arrow-up-line-duotone" />
								</div>
							</div>
							<hr className="my-4" />
							<div className="mb-5 text-body text-opacity-50 flex-1">
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Biblioteca de Setups:</span> <b className="text-body fw-semibold">Setups comuns</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Backtests:</span> <b className="text-body fw-semibold">Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Portfólios:</span> <b className="text-body fw-semibold">Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Realtime:</span> <b className="text-body fw-semibold">5 contas</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Histórico:</span> <b className="text-body fw-semibold"> 5 contas</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Simulação de Monte Carlo p/ Backtests:</span> <b className="text-body fw-semibold"> Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Simulação de Monte Carlo p/ Portfólios:</span> <b className="text-body fw-semibold"> Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">SDK:</span> <b className="text-body fw-semibold"> 2 contas</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">WFA p/ SDK:</span> <b className="text-body fw-semibold"> Habilitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Análise de Base de Dados:</span> <b className="text-body fw-semibold"> Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Auto Data Miner (BotSpot Explorer):</span> <b className="text-body fw-semibold"> Até 30 configurações</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">WFA p/ robôs proprietários:</span> <b className="text-body fw-semibold"> Não</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Análise de Volatilidade:</span> <b className="text-body fw-semibold"> Não</b></div>
								</div>
							</div>
							<div className="mx-n2">
								<a href="https://botspot.com.br/site/bs-redirect.html?to=buy.stripe.com/3cs6rleY035xgb6eV1?prefilled_promo_code=BIBLIOTECAQUANT" target='_blank' className="btn btn-outline-theme btn-lg py-3 fs-13px w-100 font-monospace">Assinar <i className="fa fa-arrow-right"></i></a>
							</div>
						</CardBody>
					</Card>
				</div>
				<div className="col-xl-3 col-md-6 py-3 py-xl-5">
					<Card className="h-100">
						<CardBody className="p-4 p-lg-5 d-flex flex-column">
							<div className="d-flex align-items-center">
								<div className="flex-1">
									<div className="h6 font-monospace mb-3">Black Mensal</div>
									<div className="display-6 mb-0 text-theme">R$ 397 <small className="h6 fw-light text-body text-opacity-50">/mês</small></div>
								</div>
								<div>
									<Icon className="display-4 text-theme" icon="solar:buildings-line-duotone" />
								</div>
							</div>
							<hr className="my-4" />
							<div className="mb-5 text-body text-opacity-50 flex-1">
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Biblioteca de Setups:</span> <b className="text-body fw-semibold">Todos os setups</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Backtests:</span> <b className="text-body fw-semibold">Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Portfólios:</span> <b className="text-body fw-semibold">Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Realtime:</span> <b className="text-body fw-semibold">Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Histórico:</span> <b className="text-body fw-semibold">Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Simulação de Monte Carlo p/ Backtests:</span> <b className="text-body fw-semibold"> Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Simulação de Monte Carlo p/ Portfólios:</span> <b className="text-body fw-semibold"> Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">SDK:</span> <b className="text-body fw-semibold">Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">WFA p/ SDK:</span> <b className="text-body fw-semibold"> Habilitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Análise de Base de Dados:</span> <b className="text-body fw-semibold"> Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Auto Data Miner (BotSpot Explorer):</span> <b className="text-body fw-semibold"> Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">WFA p/ robôs proprietários:</span> <b className="text-body fw-semibold"> Habilitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Análise de Volatilidade:</span> <b className="text-body fw-semibold"> Ilimitado</b></div>
								</div>
							</div>
							<div className="mx-n2">
								<a href="https://botspot.com.br/site/bs-redirect.html?to=buy.stripe.com/bIY6rl9DGeOf9MI6os" target='_blank' className="btn btn-outline-theme btn-lg py-3 fs-13px w-100 font-monospace">Assinar <i className="fa fa-arrow-right"></i></a>
							</div>
						</CardBody>
					</Card>
				</div>
				<div className="col-xl-3 col-md-6 py-3 py-xl-5">
					<Card className="h-100">
						<CardBody className="p-4 p-lg-5 d-flex flex-column">
							<div className="d-flex align-items-center">
								<div className="flex-1">
									<div className="h6 font-monospace mb-3">Black Anual [OFERTA DE LANÇAMENTO]</div>
									<div className="display-6 mb-0 text-theme">$3.000 <small className="h6 fw-light text-body text-opacity-50">/ano</small></div>
								</div>
								<div>
									
									<Icon className="display-4 text-theme" icon="solar:cup-first-line-duotone" />
								</div>
							</div>
							<hr className="my-4" />
							<div className="mb-5 text-body text-opacity-50 flex-1">
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Biblioteca de Setups:</span> <b className="text-body fw-semibold">Todos os setups</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Backtests:</span> <b className="text-body fw-semibold">Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Portfólios:</span> <b className="text-body fw-semibold">Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Realtime:</span> <b className="text-body fw-semibold">Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Histórico:</span> <b className="text-body fw-semibold">Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Simulação de Monte Carlo p/ Backtests:</span> <b className="text-body fw-semibold"> Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Simulação de Monte Carlo p/ Portfólios:</span> <b className="text-body fw-semibold"> Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">SDK:</span> <b className="text-body fw-semibold">Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">WFA p/ SDK:</span> <b className="text-body fw-semibold"> Habilitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Análise de Base de Dados:</span> <b className="text-body fw-semibold"> Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Auto Data Miner (BotSpot Explorer):</span> <b className="text-body fw-semibold"> Ilimitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">WFA p/ robôs proprietários:</span> <b className="text-body fw-semibold"> Habilitado</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Análise de Volatilidade:</span> <b className="text-body fw-semibold"> Ilimitado</b></div>
								</div>
							</div>
							<div className="mx-n2">
								<a href="https://botspot.com.br/site/bs-redirect.html?to=buy.stripe.com/6oEdTNdTWaxZ6Aw28g?prefilled_promo_code=BIBLIOTECABLACK" target='_blank' className="btn btn-outline-theme btn-lg py-3 fs-13px w-100 font-monospace">Assinar <i className="fa fa-arrow-right"></i></a>
							</div>
						</CardBody>
					</Card>
				</div>
			</div>
		</div>
	)
}

export default Oferta;